import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-slate-900 to-slate-800 text-slate-200">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="text-2xl font-bold">BlueShield Labs</div>
          <div className="text-sm text-slate-400 mt-2">
            Innovate • Secure • Scale
          </div>
          <p className="text-xs text-slate-500 mt-4">
            © {new Date().getFullYear()} BlueShield Labs. All rights reserved.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-3 text-white">Company</h4>
          <ul className="text-sm text-slate-300 space-y-2">
            <li>About</li>
            <li>Services</li>
            <li>Careers</li>
            <li>Contact</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-3 text-white">Contact</h4>
          <p className="text-sm text-slate-300">Priyanka Reddy Lekireddy</p>
          <p className="text-sm text-slate-300">hr@blueshieldlabs.com</p>
          <p className="text-sm text-slate-300">+1 (940) 290-4554</p>
          <p className="text-sm text-slate-300 mt-3">1413 David Dr, Anna, Texas 75409</p>
        </div>
      </div>

      <div className="border-t border-white/6">
        <div className="max-w-7xl mx-auto px-6 py-4 text-xs text-slate-500 flex justify-between">
          <div>Website: www.blueshieldlabs.com</div>
          <div>Designed with ♥ for modern teams</div>
        </div>
      </div>
    </footer>
  );
}
